import { useEffect, useState } from "react";

import "./Home.css";
import { SECTIONS } from "../../data";
import About from "../about/About";
import Skills from "../skills/Skills";
import Leftbar from "../leftbar/Leftbar";
import Projects from "../projects/Projects";
import Experience from "../experience/Experience";
import Certifications from "../certifications/Certifications";
import VoiceAssistant from "../voice-assistant/VoiceAssistant";

function Home() {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const { ABOUT, EXPERIENCE, SKILLS, CERTIFICATIONS, PROJECTS } = SECTIONS;

    const { bottom: aboutBottom } = document
      .getElementById(ABOUT)
      .getBoundingClientRect();
    const { bottom: experienceBottom } = document
      .getElementById(EXPERIENCE)
      .getBoundingClientRect();
    const { bottom: skillsBottom } = document
      .getElementById(SKILLS)
      .getBoundingClientRect();
    const { bottom: certificationsBottom } = document
      .getElementById(CERTIFICATIONS)
      .getBoundingClientRect();
    const { bottom: projectsBottom } = document
      .getElementById(PROJECTS)
      .getBoundingClientRect();

    if (aboutBottom >= 10) {
      setActiveSection(ABOUT);
    } else if (experienceBottom >= 10) {
      setActiveSection(EXPERIENCE);
    } else if (skillsBottom >= 10) {
      setActiveSection(SKILLS);
    } else if (certificationsBottom >= 10) {
      setActiveSection(CERTIFICATIONS);
    } else if (projectsBottom >= 10) {
      setActiveSection(PROJECTS);
    }
  };

  return (
    <div className="Home">
      <VoiceAssistant />
      <Leftbar activeSection={activeSection} />
      <div className="right">
        <About />
        <Experience />
        <Skills />
        <Certifications />
        <Projects />
      </div>
    </div>
  );
}

export default Home;
